import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { apiService } from '../services/api.js'

export const useProductsStore = defineStore('products', () => {
  // State
  const products = ref([])
  const loading = ref(false)
  const error = ref(null)
  const currentProduct = ref(null)

  // Getters
  const getProductById = computed(() => {
    return (id) => products.value.find(product => product._id === id || product.id === id)
  })

  const getProductsByCategory = computed(() => {
    return (category) => products.value.filter(product => product.category === category)
  })

  // Actions
  const fetchProducts = async (params = {}) => {
    try {
      loading.value = true
      error.value = null
      
      const response = await apiService.getProducts(params)
      products.value = response.products || response || []
      
      return response
    } catch (err) {
      error.value = err.message || 'Failed to fetch products'
      console.error('Error fetching products:', err)
      throw err
    } finally {
      loading.value = false
    }
  }

  const fetchProduct = async (id) => {
    try {
      loading.value = true
      error.value = null
      
      const response = await apiService.getProduct(id)
      currentProduct.value = response.product || response
      
      return response
    } catch (err) {
      error.value = err.message || 'Failed to fetch product'
      console.error('Error fetching product:', err)
      throw err
    } finally {
      loading.value = false
    }
  }

  const searchProducts = async (query, filters = {}) => {
    try {
      loading.value = true
      error.value = null
      
      const params = {
        search: query,
        ...filters
      }
      
      const response = await apiService.getProducts(params)
      products.value = response.products || response || []
      
      return response
    } catch (err) {
      error.value = err.message || 'Failed to search products'
      console.error('Error searching products:', err)
      throw err
    } finally {
      loading.value = false
    }
  }

  const clearError = () => {
    error.value = null
  }

  const clearCurrentProduct = () => {
    currentProduct.value = null
  }

  return {
    // State
    products,
    loading,
    error,
    currentProduct,
    
    // Getters
    getProductById,
    getProductsByCategory,
    
    // Actions
    fetchProducts,
    fetchProduct,
    searchProducts,
    clearError,
    clearCurrentProduct
  }
}) 